import { useRouter } from 'next/router'
import { HIGHLIGHT_TAG_MAP, HighlightItem } from '../../../../../model/caf.interface'

import { sortBy } from 'lodash'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import SortedHightlightListSection from '../../common/SortedHighlightListSection'

type AdditionalListData = {
  zscore_sum: number
  average_count: number
  tag: number
}
type SortOption = {
  label: string
  value: number
  name: string
}
interface ListData extends Partial<HighlightItem>, AdditionalListData {}
const useHighlightSortedList = (
  originList: ListData[],
  sortOption: SortOption,
  onClickItem = () => null,
  editable = false
) => {
  const { t, isLocaleKO } = useTranslation()
  const router = useRouter()
  if (!originList || originList.length === 0) return []
  const getList = (originList: ListData[], sortOption: SortOption) => {
    if (sortOption.value === 1) {
      // recommended
      const weaknessList = sortBy(
        originList.filter((item) => item.zscore_sum > 0 && item.average_count),
        'zscore_sum'
      ).reverse()
      const strengthList = sortBy(
        originList.filter((item) => item.zscore_sum <= 0 || item.average_count === 0),
        'zscore_sum'
      )
      return [
        <SortedHightlightListSection
          name={t(n_caf.highlight_list.weakness1)}
          description={''}
          data={weaknessList}
          onClickItem={onClickItem}
          editable={editable}
          key={`recommended_list_1`}
        />,
        <SortedHightlightListSection
          name={t(n_caf.highlight_list.strength1)}
          description={''}
          data={strengthList}
          onClickItem={onClickItem}
          editable={editable}
          key={`recommended_list_2`}
        />,
      ]
    } else if (sortOption.value === 2) {
      // count
      const countDecreasedList = sortBy(originList, 'average_count').reverse()
      return [
        <SortedHightlightListSection
          name={null}
          description={null}
          data={countDecreasedList}
          key={`count_list_1`}
          onClickItem={onClickItem}
          editable={editable}
        />,
      ]
    } else {
      // category
      const complexityList = originList?.filter(
        (item) =>
          item.tag == HIGHLIGHT_TAG_MAP['repetition'] ||
          item.tag == HIGHLIGHT_TAG_MAP['ros'] ||
          item.tag == HIGHLIGHT_TAG_MAP['sentence_structure']
      )
      const accuracyList = originList?.filter((item) => item.tag <= 12)
      const fluencyList = originList?.filter(
        (item) => item.tag == HIGHLIGHT_TAG_MAP['speech_rate'] || item.tag == HIGHLIGHT_TAG_MAP['filler_word']
      )
      const pronunciationList = originList?.filter((item) => item.tag == HIGHLIGHT_TAG_MAP['pronunciation'])
      return [
        <SortedHightlightListSection
          name={t(n_caf.overview.menu_complexity)}
          description={isLocaleKO ? t(n_caf.highlight_list.complexity2) : ''}
          data={complexityList}
          key={`category_list_1`}
          editable={editable}
          onClickItem={onClickItem}
        />,
        <SortedHightlightListSection
          name={t(n_caf.overview.menu_accuracy)}
          description={isLocaleKO ? t(n_caf.highlight_list.accuracy2) : ''}
          data={accuracyList}
          key={`category_list_2`}
          editable={editable}
          onClickItem={onClickItem}
        />,
        <SortedHightlightListSection
          name={t(n_caf.overview.menu_fluency)}
          description={isLocaleKO ? t(n_caf.highlight_list.fluency2) : ''}
          data={fluencyList}
          key={`category_list_3`}
          editable={editable}
          onClickItem={onClickItem}
        />,
        <SortedHightlightListSection
          name={t(n_caf.overview.pronunciation)}
          description={isLocaleKO ? t(n_caf.highlight_list.pronunciation2) : ''}
          data={pronunciationList}
          key={`category_list_4`}
          editable={editable}
          onClickItem={onClickItem}
        />,
      ]
    }
  }
  return getList(originList, sortOption)
}

export default useHighlightSortedList
